import { Box, Skeleton } from '@moosend/mooskin';
import * as React from 'react';

interface IStatBox {
	text: string;
	color?: string;
	isLoaded?: boolean;
}

export const StatBox: React.FC<IStatBox> = (props) => {
	return (
		<Box
			w="175px"
			h="100%"
			d="flex"
			minH={45}
			borderRadius={3}
			border="1px solid"
			borderColor="borderColors.gray1"
			ml="10px"
			align="center"
			p="0 10px"
		>
			<Box w="46%" fontSize="12px" fontWeight="500" lineHeight="1.25" fontColor="fontColors.text">
				{props.text}
			</Box>
			<Box w="54%" textAlign="right" fontSize="20px" fontWeight="bold" fontColor={props.color ?? 'fontColors.text'}>
				<Skeleton isLoaded={props.isLoaded} w="100%">
					{props.children}
				</Skeleton>
			</Box>
		</Box>
	);
};
